/**
 * Build-time templated share images (F38): `/og/<public path>.png`, rendered by
 * scripts/generate-og-images.mjs from each prerendered page's own og:title.
 * Shared by SEOHead.tsx, scripts/prerender-tools.mjs and the generator so the URL scheme cannot drift.
 */

export const OG_TEMPLATE_IMAGE_WIDTH = 1200;
export const OG_TEMPLATE_IMAGE_HEIGHT = 630;
export const OG_TEMPLATE_IMAGE_TYPE = 'image/png';
export const OG_TEMPLATE_DIR = '/og';

/** Logical first segment → section label printed on the image. */
export const OG_TEMPLATE_SECTIONS = {
  services: { en: 'Services', tr: 'Hizmetler' },
  solutions: { en: 'Solutions', tr: 'Çözümler' },
  tools: { en: 'Tools', tr: 'Araçlar' },
  blog: { en: 'Blog', tr: 'Blog' },
  guides: { en: 'Guides', tr: 'Rehberler' },
  playbooks: { en: 'Playbooks', tr: 'Playbooklar' },
  'ai-answers': { en: 'AI Answers', tr: 'AI Cevapları' },
  projects: { en: 'Projects', tr: 'Projeler' },
};

/** Pages without their own image whose logical path falls under a templated section. */
export function hasTemplateOgImage(logicalPath) {
  const root = String(logicalPath || '/').split('/').filter(Boolean)[0];
  return Boolean(root && Object.prototype.hasOwnProperty.call(OG_TEMPLATE_SECTIONS, root));
}

/** `/tr/hizmetler/foo` → `/og/tr/hizmetler/foo.png` */
export function templateOgImagePath(publicPath) {
  const clean = String(publicPath || '/').split(/[?#]/)[0].replace(/\/+$/, '');
  return `${OG_TEMPLATE_DIR}${clean || '/index'}.png`;
}

export function templateOgSectionLabel(logicalPath, locale) {
  const root = String(logicalPath || '/').split('/').filter(Boolean)[0];
  const section = OG_TEMPLATE_SECTIONS[root];
  if (!section) return '';
  return locale === 'tr' ? section.tr : section.en;
}
